import { BASE_PATH } from '@/consts/environmental';

import { createAgencyApiUrls } from './createApiUrls';
import { createHydrogenUrls } from './createHydrogenUrls';
import { createAgencyLegacyUrls } from './createLegacyUrls';
import { createAgencySiteUrls } from './createSiteUrls';

const appUrl = process.env.NEXT_PUBLIC_AGENCY_APP_URL;
const siteUrl = process.env.NEXT_PUBLIC_AGENCY_SITE_URL;
const hydrogenUrl = process.env.NEXT_PUBLIC_CUROLOGY_HYDROGEN_URL;

// Agencyskin rebrand destination. Additive during the in-between state: the
// withagency URLs above stay put; consumers opt into this via
// getActiveAgencyUrls() gated on the `agency-rebrand` flag.
//
// Deliberately limited to the marketing site. `appUrl` is the origin for every
// authenticated /api call, so moving it would repoint session, CSRF and
// checkout traffic at a host the backend does not serve yet. It stays on
// withagency until app.agencyskin.com is live behind the same session.
const rebrandSiteUrl = process.env.NEXT_PUBLIC_AGENCY_REBRAND_SITE_URL;

export const agencyUrls = {
  base: `${appUrl}${BASE_PATH}`,
  api: createAgencyApiUrls(appUrl),
  legacy: createAgencyLegacyUrls(appUrl),
  site: createAgencySiteUrls(siteUrl),
  hydrogen: createHydrogenUrls(hydrogenUrl),
  rebrand: {
    site: createAgencySiteUrls(rebrandSiteUrl),
  },
};
